import { toast } from 'react-toastify'

import { axiosUserV5 } from '../../config/axios'
import { store } from '../../store/store'
import { identiaApi } from '../../store/api'

export const changePasswordService = async (password: string, token: string) => {
    let success: boolean = true

    await axiosUserV5({
        url: '/v5.0.1/api',
        method: 'post',
        data: {
            fname: 'resetPassword',
            password,
        },
        headers: { authorization: `Bearer ${token}` },
    })
        .then(({ data }) => {
            // console.log('DATAAAA!!!!: ', data)
        })
        .catch((e) => {
            success = false
            toast.error('Hubo un error inesperado')
        })

    return success
}

export const verifyTokenExpiration = async (token: string) => {
    try {
        const res: any = await store.dispatch(
            identiaApi.endpoints.validateAuth.initiate({ token }),
        )
        const payload = res?.data ?? res?.payload ?? null

        if (typeof res?.unsubscribe === 'function') res.unsubscribe()

        if (!payload) {
            toast.error('Sesión expirada, ingrese nuevamente')
            return true
        }

        return !payload.hasAccess
    } catch (e) {
        console.log('MIRALAAA: ', e, (e as any)?.response)
        toast.error('Sesión expirada, ingrese nuevamente')
        return true
    }
}
